module.exports = __webpack_public_path__ + "static/img/1-12.29f1aef.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-12.png
// module id = 213
// module chunks = 0